import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';

import './scss/industry.scss';
import Color from '@/tool/color';

import IndustryChart from './component/industry-chart';
import moHumanIndustry from './store/industry';
import IndustryIncomeChart from './component/industry-income-chart';
import Empty from '@/component/empty';
import Sub from '../component/sub';
import MainTitle from '../component/main-title';
import URI from 'urijs';


interface IProps { }
interface IState { }

const Industry = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industryList } = moHumanIndustry;
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);

  const emen: any = {
    多指标: 'multi_indicator',
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };

  const showList = (val: string) => {
    const active = emen[val];
    let list: any = [];
    if (industryList) {
      list = industryList[active]?.overview;
    }
    return list;
  };

  const xData = useMemo(() => {
    const xList: any = [];
    const costList: any = [];
    const profitList: any = [];
    const revenueList: any = [];
    industryList?.multi_indicator?.detail?.forEach((res: any) => {
      xList.push(res.label);
      costList.push(res.cost_per_staff_ratio);
      profitList.push(res.profit_per_staff_ratio);
      revenueList.push(res.revenue_per_staff_ratio);
    });
    return {
      xList, costList, profitList, revenueList,
    };
  }, [industryList]);

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect01" className="effect-industry-pdf-warp human-common-pdf">
      <MainTitle
        title='行业对比'
        subtitle='多行业比对'
        year={data.tabList.at}
        bgcolor={Color.secondaryColor(0.1)}
        color={Color.secondary} />
      {data.tabList?.a1 && <section>
        <Sub title='多指标' />
        <section className="chart-demo">
          {(xData.costList.filter((res: any) => res).length > 0 ||
            xData.profitList.filter((res: any) => res).length > 0 ||
            xData.revenueList.filter((res: any) => res).length > 0
          ) ? < IndustryChart /> : <Empty />}
        </section>
        {!isEmpty(showList('多指标')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('多指标')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.a2 && <section>
        <Sub title='人均营业收入' />
        <IndustryIncomeChart activeTab="人均营业收入" />
        {!isEmpty(showList('人均营业收入')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('人均营业收入')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.a3 && <section>
        <Sub title='人均净利润' />
        <IndustryIncomeChart activeTab="人均净利润" />
        {!isEmpty(showList('人均净利润')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('人均净利润')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.a4 && <section>
        <Sub title='人均薪酬成本' />
        <IndustryIncomeChart activeTab="人均薪酬成本" />
        {!isEmpty(showList('人均薪酬成本')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('人均薪酬成本')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 0)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.a5 && <section>
        <Sub title='元均营业收入' />
        <IndustryIncomeChart activeTab="元均营业收入" />
        {!isEmpty(showList('元均营业收入')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('元均营业收入')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.a6 && <section>
        <Sub title='元均净利润' />
        <IndustryIncomeChart activeTab="元均净利润" />
        {!isEmpty(showList('元均净利润')) && <section className="chart-detail industry-detail">
          <section>注：</section>
          {
            showList('元均净利润')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? (ele.mark === 'change_ratio' ? `${round(ele.value * 100, 1)}%` : round(ele.value, 1)) : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}
    </section>
  );
};

export default observer(Industry);
